import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
// import { history } from 'app/history';
import {
  get_Countrycodes,
  get_statusData,
  horoscopeData,
  get_MStatus,
  detailsList,
  getMasters
} from './api';

const initialState = {
  loading: false,
  createhoroscopeDetailsloading: false,
  country_codes: [],
  state_details: [],
  city_details: [],
  user_data: [],
  star_details: [],
  rasi_details: []
};

const actions = {
  COUNTRYCODES: 'countryCodes/COUNTRYCODES',
  STATECODES: 'stateCodes/STATECODES',
  CITIES_LIST: 'citieslist/CITIES_LIST',
  CREATEHOROSCOPEDETAILS: 'createhoroscopeDetails/CREATEHOROSCOPEDETAILS',
  GET_BYID: 'get_byID/GET_BYID',
  STARLIST: 'starlist/STARLIST',
  RASILIST: 'rasilist/RASILIST'
};

export const get_byID = createAsyncThunk(actions.GET_BYID, async (payload) => {
  const response = await detailsList(payload);
  return response;
});

// starlist/STARLIST
export const starlist = createAsyncThunk(actions.STARLIST, async (payload) => {
  const response = await getMasters('star-signs-list', payload);
  return response;
});

// rasilist/RASILIST
export const rasilist = createAsyncThunk(actions.RASILIST, async (payload) => {
  const response = await getMasters('zodiac-signs-list', payload);
  return response;
});

export const countryCodes = createAsyncThunk(
  actions.COUNTRYCODES,
  async (payload) => {
    const response = await get_Countrycodes('countries-list', payload);
    return response;
  }
);

// stateCodes/STATECODES
export const stateCodes = createAsyncThunk(
  actions.STATECODES,
  async (payload) => {
    const response = await get_statusData('states-list', payload);
    return response;
  }
);

// cities_list/CITIES_LIST
export const citieslist = createAsyncThunk(
  actions.CITIES_LIST,
  async (payload) => {
    const response = await get_MStatus('cities-list', payload);
    return response;
  }
);

// createhoroscopeDetails/CREATEHOROSCOPEDETAILS
export const createhoroscopeDetails = createAsyncThunk(
  actions.CREATEHOROSCOPEDETAILS,
  async (payload) => {
    const response = await horoscopeData('horoscope', payload);
    return response;
  }
);

export const EditHoroscopeDetailsSlice = createSlice({
  name: 'edithoroscope',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(countryCodes.pending, (state) => {
        state.loading = true;
      })
      .addCase(countryCodes.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.country_codes = data;
      })
      .addCase(countryCodes.rejected, (state) => {
        state.loading = false;
      });

    // stateCodes
    builder
      .addCase(stateCodes.pending, (state) => {
        state.loading = true;
      })
      .addCase(stateCodes.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.state_details = data;
      })
      .addCase(stateCodes.rejected, (state) => {
        state.loading = false;
      });

    // cities_list
    builder
      .addCase(citieslist.pending, (state) => {
        state.loading = true;
      })
      .addCase(citieslist.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.city_details = data;
      })
      .addCase(citieslist.rejected, (state) => {
        state.loading = false;
      });

    // starlist/STARLIST
    builder
      .addCase(starlist.pending, (state) => {
        state.loading = true;
      })
      .addCase(starlist.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.star_details = data;
      })
      .addCase(starlist.rejected, (state) => {
        state.loading = false;
      });

    // rasilist/RASILIST
    builder
      .addCase(rasilist.pending, (state) => {
        state.loading = true;
      })
      .addCase(rasilist.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.rasi_details = data;
      })
      .addCase(rasilist.rejected, (state) => {
        state.loading = false;
      });

    // createhoroscopeDetails
    builder
      .addCase(createhoroscopeDetails.pending, (state) => {
        state.createhoroscopeDetailsloading = true;
      })
      .addCase(createhoroscopeDetails.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.createhoroscopeDetailsloading = false;
        state.state_details = data;
      })
      .addCase(createhoroscopeDetails.rejected, (state) => {
        state.createhoroscopeDetailsloading = false;
      });

    builder
      .addCase(get_byID.pending, (state) => {
        state.acceptedLoading = true;
      })
      .addCase(get_byID.fulfilled, (state, action) => {
        const { data } = action.payload;
        console.log('slice_View', data.Profiles);
        // state.allOnBoardingList = data.items ? data.items : [];
        // state.pagination = data.meta || null;
        state.user_data = data;

        // console.log('slicelog', data);
      })
      .addCase(get_byID.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.acceptedLoading = false;
        message.error(msg);
      });
  }
});

export default EditHoroscopeDetailsSlice.reducer;
